import * as Yup from 'yup';
import { useFormik } from 'formik';
import { GoodsRequest, GoodTypes } from '../../../modules/Goods/types';

export const goodsRequestValidationSchema = Yup.object({
  id: Yup.string(),

  dependency_id: Yup.string().required('Requerido'),
  location_id: Yup.string().required('Requerido'),
  goods_type: Yup.string().required('Requerido'),
  request_type: Yup.string(),
  
  //Tipo clase
  asset_class: Yup.string().when('goods_type', {
    is: GoodTypes.BIEN_CONSUMO_ID,
    then:(Schema) => Schema.required("Tipo clase es Requerido")
  }),

/*   status_id: Yup.string().required('Requerido'), */
  goods_location_id: Yup.string(),
  observation: Yup.string(),


  //General
  observations: Yup.string().max(500, "Debe tener un maximo de 500 carateres"),

  //Tipo de solicitud: actibos fijos
  item_quantity: Yup.string().min(1, 'La cantidad no puede ser menor a 1'),
  itemable_id: Yup.string(),

  
  //Tipo de solicitud: consumo bienes

});

interface UseGoodsRequestFormikProps {
  onSubmit: (values: GoodsRequest) => void;
}

const useGoodsRequestFormik = ({ onSubmit }: UseGoodsRequestFormikProps) => {
  return useFormik<GoodsRequest>({
    initialValues: {
      id: '',
      dependency_id: '',
      location_id: '',
      request_type: '',
      goods_location_id: '',
      goods_type: '',
      observations: '',
      item_quantity: 1,
      items: [],
      itemable_id: '',
      articleName: ''
    },
    validationSchema: goodsRequestValidationSchema,
    onSubmit,
  });
};

export default useGoodsRequestFormik;
